import { shallowEqual } from "@knyt/artisan";
// TODO: Rename for clarity
export function areStyleSheetMixinsEqual(mixinA, mixinB) {
    return shallowEqual(mixinA, mixinB, shallowEqual);
}
